$.turbo.use("turbolinks:load", "turbolinks:request-start");
